import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';

function useStore(store: 'globals'): Globals;
function useStore(store: 'coursesStore'): CoursesStore;
function useStore<T>(store: string): T {
  const stores = useContext(MobXProviderContext);
  if (!stores || !stores[store]) {
    throw new Error(`useStore must be used within a StoreProvider (${store} was not available).`);
  }
  return stores[store];
}

export default useStore;
